export const GESTURING = 'gesturing'
export const SNACKING = 'snacking'
